// extracted by mini-css-extract-plugin
export var root = "Button-module--root--2w5CA";
export var loading = "Button-module--loading--dgqbx";
export var disabled = "Button-module--disabled--3jiwL";
export var icon = "Button-module--icon--ahMay";
export var spinner = "Button-module--spinner--29kjh";
export var transparent = "Button-module--transparent--t6Qzt";